"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function When(_ref) {
  var condition = _ref.condition,
      children = _ref.children,
      props = (0, _objectWithoutProperties2.default)(_ref, ["condition", "children"]);

  if (!condition) {
    return null;
  }

  var component = (0, _react.cloneElement)(children(), props);
  return _react.default.createElement(_react.default.Fragment, null, component);
}

When.propTypes = {
  condition: _propTypes.default.bool,
  children: _propTypes.default.func
};
When.defaultProps = {
  condition: false,
  children: function children() {
    return null;
  }
};
var _default = When;
exports.default = _default;